export const onlySpaces = (data) => {
  if (typeof data === "string") {
    if (data.trim().length === 0) {
      return true;
    }
    return false;
  } else {
    return;
  }
};
export const isEmpty = (data) => (data === "" ? true : false);
export const isEmptyObject = (data) =>
  Object.keys(data).length === 0 ? true : false;

export const getObjectKeys = (data) =>
  Object.keys(data); /* returns [] of keys */
export const getObjectValues = (data) =>
  Object.values(data); /* returns [] of values */
export const getObjectEntries = (data) =>
  Object.entries(data); /* returns [] of key value pairs [key, value] */

export const policyValidation = (values, defaultDuration, butCharge) => {
  let errors = {};
  if (
    butCharge &&
    parseFloat(values.but_charge) < parseFloat(values.total_annual_premium)
  ) {
    errors.but_charge =
      "but-charge cannot be less than or equal to total annual premium";
  }
  if (values.repayment_frequency === "Biannually" && values.duration < 6) {
    errors.repayment_frequency = "The duration must be 6 months and above";
  }
  if (values.repayment_frequency === "Annually" && values.duration < 12) {
    errors.repayment_frequency = "The duration must be 1 year and above";
  }

  if (values.repayment_frequency === "Quarterly" && values.duration < 3) {
    errors.repayment_frequency = "The duration must be 3 months and above";
  }

  if (values.duration && values.duration < defaultDuration) {
    errors.duration = `The duration cannot be less than ${defaultDuration} months`;
  }

  return errors;
};

export const savingsPolicyValidator = (values, defaultDuration, rate) => {
  let errors = {};

  if (values?.interest_rate < parseFloat(rate[0]?.minimum_rate)) {
    errors.interest_rate = "rate cannot be less than " + rate[0]?.minimum_rate;
  }

  if (values?.interest_rate > rate[0]?.maximum_rate) {
    errors.interest_rate =
      "rate cannot be greater than " + rate[0]?.maximum_rate;
  }

  if (values.repayment_frequency === "Biannually" && values.duration < 6) {
    errors.repayment_frequency = "The duration must be 6 months and above";
  }

  if (values.repayment_frequency === "Annually" && values.duration < 12) {
    errors.repayment_frequency = "The duration must be 1 year and above";
  }

  if (values.repayment_frequency === "Quarterly" && values.duration < 3) {
    errors.repayment_frequency = "The duration must be 3 months and above";
  }

  if (values.duration && values.duration < defaultDuration) {
    errors.duration = `The duration cannot be less than ${defaultDuration} months`;
  }

  return errors;
};
